import { Group, Text, ThemeIcon } from '@mantine/core';
import type { ReactNode } from 'react';

/** Section heading with tan icon tile — used above appointment header tables and similar blocks. */
export function SectionHeader({
  icon,
  label,
}: {
  icon: ReactNode;
  label: string;
}): JSX.Element {
  return (
    <Group gap="sm" wrap="nowrap">
      <ThemeIcon variant="light" color="gold" radius="md" size={32}>
        {icon}
      </ThemeIcon>
      <Text size="sm" fw={500} c="gray.7">
        {label}
      </Text>
    </Group>
  );
}
